// src/components/Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const legalLinks = [
    { to: '/legal/terms-of-service', label: '利用規約' },
    { to: '/legal/privacy-policy', label: 'プライバシーポリシー' },
    { to: '/legal/commerce-notation', label: '特定商取引法に基づく表記' },
    { to: '/legal/stripe-payment-info', label: 'Stripe情報' },
    { to: '/legal/disclaimer', label: '免責事項' },
    { to: '/legal/copyright', label: '著作権表示' },
    { to: '/legal/revision-history', label: '改定履歴' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* デスクトップ・タブレット向けナビゲーション */}
          <nav className="footer-nav">
            <ul className="footer-links">
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* モバイル向けアコーディオン */}
          <div className="footer-mobile">
            <div className="footer-accordion">
              <div className="footer-accordion-item">
                <button 
                  className="footer-accordion-button"
                  onClick={() => toggleAccordion(0)}
                >
                  法的情報
                  <span>{activeAccordion === 0 ? '−' : '＋'}</span>
                </button>
                <div className={`footer-accordion-content ${activeAccordion === 0 ? 'active' : ''}`}>
                  <ul className="footer-mobile-links">
                    {legalLinks.map((link, index) => (
                      <li key={index}>
                        <Link to={link.to} className="footer-mobile-link">
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <p className="footer-copyright">
            &copy; 2025 Kanata Tsuchiya. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
